var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popup-windows-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick, "tab-remove": _vm.removeTab },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "点餐首页弹窗", name: "first" } },
            [
              _c("OrderHomePopup", {
                ref: "orderList",
                on: {
                  "add-popup": _vm.handleAddPopup,
                  "edit-popup": _vm.handleEditPopup,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "菜单页弹窗", name: "second" } },
            [
              _c("MenuPagePopup", {
                ref: "menuList",
                on: {
                  "add-popup": _vm.handleAddPopup,
                  "edit-popup": _vm.handleEditPopup,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "社区首页弹窗", name: "third" } },
            [
              _c("CommunityHomePopup", {
                ref: "communityList",
                on: {
                  "add-popup": _vm.handleAddPopup,
                  "edit-popup": _vm.handleEditPopup,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.dynamicTabs, function (tab) {
            return _c(
              "el-tab-pane",
              {
                key: tab.name,
                attrs: { label: tab.title, name: tab.name, closable: "" },
              },
              [
                _c(_vm.getFormComponent(tab.type), {
                  tag: "component",
                  attrs: {
                    "edit-id": tab.editId,
                    "is-edit": tab.isEdit,
                    "popup-type": _vm.getPopupType(tab.type),
                  },
                  on: {
                    saved: function ($event) {
                      return _vm.handleFormSaved(tab.type, tab.name)
                    },
                    cancel: function ($event) {
                      return _vm.removeTab(tab.name)
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }